import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["placeholder", "aria-describedby", "aria-required", "aria-invalid", "id"]

import { computed, inject, Ref } from "vue";
import { useRenderStore } from "@/builder/stores/renderStore";
import { FieldStyle } from "@/builder/enums";
import { PageDesign } from "../page/PageInterface";
import ValidatedInput from "@/builder/components/input/ValidatedInput.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommentsInputComponent',
  props: ["component"],
  setup(__props) {

const props = __props;
const store = useRenderStore();

const pageDesign = inject("pageDesign") as Ref<PageDesign>;
const fieldStyle = computed(() => {
    return pageDesign.value.fieldStyle;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ValidatedInput, {
    id: props.component.id,
    value: _unref(store).gift.comments,
    label: props.component.customData.label,
    accessibleLabel: "Comments",
    name: "Comments",
    class: _normalizeClass(["rd-w-full", { 'form-compact-full': fieldStyle.value == _unref(FieldStyle).Compact }]),
    isRequired: props.component.customData.required
  }, {
    input: _withCtx((inputProps) => [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).gift.comments) = $event)),
        placeholder: __props.component.customData.placeholder,
        "aria-describedby": inputProps.describedBy,
        "aria-required": inputProps.required,
        "aria-invalid": inputProps.isInvalid,
        id: __props.component.id + '_Comments',
        resize: "none",
        rows: "4"
      }, null, 8, _hoisted_1), [
        [_vModelText, _unref(store).gift.comments]
      ])
    ]),
    _: 1
  }, 8, ["id", "value", "label", "class", "isRequired"]))
}
}

})